import { useNavigate } from 'react-router-dom';

import {
  useAuth,
  useTownAssets,
} from '../../stores';
import { ConfirmPopup } from '../display';

// A recovery code usually means a lost device: the user is sent to review what the account holds
function RecoveryCodeUsedNotice() {
  const { auth } = useAuth();
  const { assets } = useTownAssets();
  const { translate } = assets;
  const navigate = useNavigate();

  if (!auth.server.recoveryCodeUsed) return null;

  return (
    <ConfirmPopup
      title={translate('twoFactorLogin')}
      question={[
        translate('recoveryCodeUsedNotice', 'statements'),
        translate('recoveryCodeUsedReview', 'questions'),
      ]}
      onConfirm={() => {
        auth.server.dismissRecoveryCodeUsed();
        // Use void to make it clear we do not want to wait this async function:
        void navigate('/profile/security');
      }}
      onReject={auth.server.dismissRecoveryCodeUsed}
    />
  );
}

export default RecoveryCodeUsedNotice;
